export const statuses: any = { Enabled: 'text-green-400 bg-green-400/10', Disabled: 'text-rose-400 bg-rose-400/10' };